import { Component, Emit, Vue, Prop, Watch} from 'vue-property-decorator'
import { DisposalRecordList, ShippingDestinationList, WeightUnit, SelectAgriFieldAndPlanting,DisposalRecordItem } from "@/types/Component"
import SelectFromPlantings from '@/components/Record/SelectFromPlantings/SelectFromPlantings.vue';
import SelectFromAgriFields from '@/components/Record/SelectFromAgriFields/SelectFromAgriFields.vue';
import store from '@/assets/common/store/store';
import moment from 'moment';

@Component({
  components: {
    SelectFromPlantings,
    SelectFromAgriFields
  }
})

export default class DisposalRecord extends Vue {
  baseUrl = '/disposal_records';
  selectScreenManagement = '/graphScreenManagement';
  initialRecordList = [] as DisposalRecordList;
  disposalRecordList = [] as DisposalRecordList;
  private weightUnits : Array<WeightUnit> = []
  private shippingDestinationList = [] as ShippingDestinationList[];
  private selectedItems : any = ""
  private selectedDestinationId = null;
  private selectedWeightUnitId = null;
  private selectedWeightUnitName = "";
  dateInput : any = '';
  private inputChangeFlag = false; 
  private monthDates : any = "";
  private date = moment(new Date()).format('YYYY-MM-DD')
  private showSelectFromPlantings = false;
  private showSelectFromAgriFields = false;
  private showResult = false;
  private plantingAndAgriField : SelectAgriFieldAndPlanting = {
    agriField: {
      id: '',
      name: '',
      plantedArea: 0
    },
    planting: {
      id: '',
      name: '',
      cropFamicId: ''
    }
  }
  startDate: string | Date = new Date();
  endDate: string | Date = new Date();

  @Prop() isDisposalModal!:boolean;
  
  get isDisposalModalOpen(): boolean {
    return(
    this.showSelectFromPlantings ||
    this.showSelectFromAgriFields
    )
  }

  @Watch('showSelectFromPlantings')
  disposalModalChanged(){
    if(this.showSelectFromPlantings === true){
      this.$emit('update:isDisposalModal', true);
    }else{
      this.$emit('update:isDisposalModal', false);
    }
  }

  @Watch('isDisposalModalOpen')
  disposalPopupChanged(val:boolean){
    this.$root.$emit('header-inert', val);
  }

  @Watch('showSelectFromAgriFields')
  disposalChanged(){
    if(this.showSelectFromAgriFields === true){
        this.$emit('update:isDisposalModal', true);
    }else{
        this.$emit('update:isDisposalModal', false);
    }
  }

  private created() {
    this.setCurrentmonth()
    this.getWeightUnits()
    this.getDisposalRecords()
    this.getShippingDestinations()
    this.monthDatesArr()
  }

  private getDisposalRecords() {
    this.$apiClient.doRequest('get', `${this.baseUrl}?date=${this.dateInput}`).then(res => {
      this.initialRecordList = res.disposalRecord
      this.initialRecordList.forEach(record => {
        record.quantity = record.quantity != "" ? (record.quantity * 100) / 100 : "";
        record.unitPrice = record.unitPrice != "" ? Math.round(record.unitPrice * 100) / 100 : "";
      });
      setTimeout(() => {
        if (res.disposalRecord.length > 0) {
          const selectedPeriod = new Date(res.disposalRecord[0].disposalDate);
          this.disposalRecordList = this.monthDatesArrWithDatas(selectedPeriod.getFullYear(),selectedPeriod.getMonth()+1)
        } else if(this.selectedDestinationId) {
          const selectedPeriod = new Date(this.dateInput);
          this.disposalRecordList = this.monthDatesArrWithDatas(selectedPeriod.getFullYear(),selectedPeriod.getMonth()+1)
        }
      }, 100);
      this.selectedItems = res.selectedItems
      this.selectedDestinationId = res.selectedItems.shippingDestinationId;
      this.selectedWeightUnitId = res.selectedItems.weightUnitId;
      this.plantingAndAgriField = {
        agriField: {
          id: res.selectedItems.agriFieldId || '',
          name: res.selectedItems.agriFieldName || '',
          plantedArea: 0
        },
        planting: {
          id: res.selectedItems.plantingId || '',
          name: res.selectedItems.plantingName || '',
          cropFamicId: ''
        }
      }
      const foundObject = this.weightUnits.find(obj => obj.id === this.selectedWeightUnitId);
       this.selectedWeightUnitName = foundObject?.name || "kg"
      this.showResult = true;
    })
  }

  private getObjectById(id: string|null) {
    return this.weightUnits.find(obj => obj.id === id);
  }

  monthDatesArrWithDatas (sYear: number, sMonth: number) {
    this.monthDates = this.getMonthRangeDates(sYear,sMonth);
    const monthDates = this.monthDates;
    const arr = [] as any;
    monthDates.map((item:any) => {
      const matchedRecord = this.initialRecordList.find((date:any) => date.disposalDate == item);
      if (matchedRecord) {
        const { disposalDate }  = matchedRecord
        matchedRecord.disposalDate = this.formateDateArr(disposalDate);
        arr.push(matchedRecord)
      } else {
        const record = {
          disposalDate: this.formateDateArr(item),
          quantity: "",
          amount: "",
          shippingDate: ""
        }
        arr.push(record)
      }
    })
    return arr;
  }

  formateDateArr(date: string) {
    const parsedDate = new Date(date);
    const year = parsedDate.getFullYear();
    const month = String(parsedDate.getMonth() + 1).padStart(2, '0');
    const day = String(parsedDate.getDate()).padStart(2, '0');
    return `${year}/${month}/${day}`;
  }

  monthDatesArr () {
    const inputDate = new Date(this.dateInput + "-01"); 
    const year = inputDate.getFullYear(); 
    const month = inputDate.getMonth() + 1;
    this.monthDates = this.getMonthRangeDates(year,month);
    const monthDates = this.monthDates;
  }

  private setCurrentmonth() {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const formattedDate = `${year}-${month}`;
    this.dateInput = formattedDate
  }

  getShippingDestinations() {
    this.$apiClient.doRequest('get', `/admin/shipping_destinations?with_hidden=true`).then(ret => {
      this.shippingDestinationList = ret.shipping_destinations;
    })
  }

  getWeightUnits() {
    this.$apiClient.doRequest('get', `/weight_units?with_hidden=true`).then(ret => {
      this.weightUnits = ret.weight_units;
    })
  }

  private moveBackward() {
    if (this.inputChangeFlag == true) {
      if (!window.confirm("保存していません。よろしいですか？")) {
        return false
      }
    }
    this.inputChangeFlag = false;
    const inputDate = new Date(this.dateInput + "-01"); 
    inputDate.setMonth(inputDate.getMonth() - 1);
    this.dateInput = inputDate.toISOString().slice(0, 7);
    this.monthDatesArr();
    this.getDisposalRecords();
  }

  private moveForward() {
    if (this.inputChangeFlag == true) {
      if (!window.confirm("保存していません。よろしいですか？")) {
        return false
      }
    }
    this.inputChangeFlag = false;
    const inputDate = new Date(this.dateInput + "-01"); 
    inputDate.setMonth(inputDate.getMonth() + 1);
    this.dateInput = inputDate.toISOString().slice(0, 7);
    this.monthDatesArr();
    this.getDisposalRecords();
  }

  private datechange() {
    if (this.inputChangeFlag == true) {
      if(!window.confirm("保存していません。よろしいですか？")) {
        return false
      }
    }
    const inputDate = new Date(this.dateInput + "-01"); 
    inputDate.setMonth(inputDate.getMonth());
    this.dateInput = inputDate.toISOString().slice(0, 7);
    this.monthDatesArr();
    this.getDisposalRecords();
  }
 
  private getMonthRangeDates(year: any, month: any) {
    const startDate = new Date(year, month - 1, 1);
    const endDate = new Date(year, month, 0);
    const dates = [];
    this.startDate = moment(startDate).format('YYYY-MM-DD');
    this.endDate = moment(endDate).format('YYYY-MM-DD');
    while (startDate <= endDate) {
      const yearStr = startDate.getFullYear();
      const monthStr = (startDate.getMonth() + 1).toString().padStart(2, '0');
      const dayStr = startDate.getDate().toString().padStart(2, '0');
      const formattedDate = `${yearStr}-${monthStr}-${dayStr}`;
      dates.push(formattedDate);
      startDate.setDate(startDate.getDate() + 1);
    }
    return dates;
  }

  private inputChange() {
    this.inputChangeFlag = true;
    this.inputChanged();
  }
 
  private handleSearch() {  
    if (this.inputChangeFlag == true) {
      if (!window.confirm("保存していません。よろしいですか？")) {
        return false
      }
    }
    this.inputChangeFlag = false;
    if (this.selectedDestinationId == null) {
      window.alert("出荷先を選択ください。")
      return false
    }
    if (this.plantingAndAgriField.agriField.id == '' || this.plantingAndAgriField.planting.id == '') {
      window.alert("作付・圃場を選択してください。")
      return false
    }
    const params = {
      destinationId: this.selectedDestinationId,
      agriFieldId: this.plantingAndAgriField.agriField.id,
      plantingId: this.plantingAndAgriField.planting.id,
      weightUnitId: this.selectedWeightUnitId,
      screenName:'DISPOSALRECORDS',
    }
    this.$apiClient.doRequest('post', `${this.selectScreenManagement}`,params).then(ret => {
      this.getDisposalRecords();
      this.$store.dispatch('doUpdateIsInputChanged', false);
    })
    this.inputChangeFlag = false;
  }

  async saveRecord() {
    const errMsg: string[] = [] 
    const disposalRecordData = this.disposalRecordList.filter(item=> item.quantity || item.amount || item.shippingDate || item.unitPrice).map(data => {
      const quantityStr = data.quantity?.toString().split('.')
      if (data.quantity == "" || data.quantity == null) {
        errMsg.push(`廃棄数を入力してください(廃棄日：${data.disposalDate})`)
      } else {
        if (data.quantity < 0 || quantityStr[0].length > 7 || (quantityStr[1] && quantityStr[1].length > 2)) {
          errMsg.push(`廃棄数は0以上の整数部7桁小数部2桁までの数値を入力してください(廃棄日：${data.disposalDate})`)
        }
        if ((data.amount == "" || data.amount == null) && data.quantity > 0 ) {
          errMsg.push(`金額を入力してください(廃棄日：${data.disposalDate})`)
        }else if(data.amount.toString().length > 7){
          errMsg.push(`金額は0-7桁までの数値を入力してください(廃棄日：${data.disposalDate})`)
        }
        if(data.unitPrice!=null){
          const unitPriceStr = data.unitPrice.toString().split('.')
          if(unitPriceStr[0].length > 7 || (unitPriceStr[1] && unitPriceStr[1].length > 2)){
            errMsg.push(`単価は整数部7桁小数部2桁までの数値を入力してください(廃棄日：${data.disposalDate})`)
          }
        }
      }
  
      return {
        diposal_date: data.disposalDate,      
        disposal_quantity: data.quantity,
        amount: data.amount,
        unit_price:data.unitPrice,
        shipping_date: data.shippingDate || null,
      }
    })
    if (errMsg.length > 0) {
      window.alert(errMsg.join('\n'))
      return false
    }
    const params = {
      shipping_destination_id: this.selectedDestinationId,
      agri_field_id: this.plantingAndAgriField.agriField.id,
      planting_id: this.plantingAndAgriField.planting.id,
      weight_unit_id: this.selectedWeightUnitId,
      disposal_record_data: disposalRecordData,
      startDate: this.startDate,
      endDate: this.endDate
    }
  
    if (this.inputChangeFlag == true) {
      this.$apiClient.doRequest('post', `${this.baseUrl}`,params).then(ret => {
        this.$toasted.success('保存しました。')
        this.inputChangeFlag = false;
        this.$store.dispatch('doUpdateIsInputChanged', false);
      })
    }
  }

  async cancelRecord() {
    if (this.inputChangeFlag == true) {
      if (!window.confirm("変更内容を破棄します。よろしいですか。")) {
        return false
      }
    }
    this.inputChangeFlag = false;
    this.$store.dispatch('doUpdateIsInputChanged', false);
    this.getDisposalRecords();
  }

  private commitPlantingAndField(item: SelectAgriFieldAndPlanting) {
    this.showSelectFromPlantings = false
    this.showSelectFromAgriFields = false
    this.plantingAndAgriField = {
      agriField: {
        id: item.agriField.id,
        name: item.agriField.name,
        plantedArea: 0
      },
      planting: {
        id: item.planting.id || '',
        name: item.planting?.name,
        cropFamicId: ''
      }
    }
    this.showResult = false;
    this.inputChanged();
  }

  private handleSelectChange() {
    if (this.inputChangeFlag == true) {
      if (!window.confirm("保存していません。よろしいですか？")) {
      this.selectedDestinationId = this.selectedItems.shippingDestinationId;
      this.selectedWeightUnitId = this.selectedItems.weightUnitId;
      this.plantingAndAgriField = {
        agriField: {
          id: this.selectedItems.agriFieldId || '',
          name: this.selectedItems.agriFieldName || '',
          plantedArea: 0
        },
        planting: {
          id: this.selectedItems.plantingId || '',
          name:this.selectedItems.plantingName || '',
          cropFamicId: ''
        }
      }
        const foundObject = this.weightUnits.find(obj => obj.id === this.selectedWeightUnitId);
       this.selectedWeightUnitName = foundObject?.name || "kg"
      this.showResult = true;
      return false
      }
    }
    this.showResult = false;
    this.inputChangeFlag = false;
    this.inputChanged();
  }

  calcUnitPrice(disposalDetail: DisposalRecordItem) {
    if(!disposalDetail.quantity || disposalDetail.quantity == 0 || !disposalDetail.amount) {
      disposalDetail.unitPrice = null
    } else {
      const calc = disposalDetail.amount / disposalDetail.quantity
      disposalDetail.unitPrice = Math.round(calc * 100) / 100
    }
  }

  calcAmount(disposalDetail: DisposalRecordItem) {
    if(!disposalDetail.quantity || !disposalDetail.unitPrice) {
      disposalDetail.amount = null
    } else {
      const calc = disposalDetail.quantity * disposalDetail.unitPrice
      disposalDetail.amount = Math.round(calc)
    }
  }
  @Emit('inputChanged')
    private inputChanged(){
        if(store.getters.isInputChanged==false){
         this.$store.dispatch('doUpdateIsInputChanged', true);
        }
    }
  
  private selectFromPlantings(){
    if (this.inputChangeFlag == true) {
      if (!window.confirm("保存していません。よろしいですか？")) {
        return false
      }
    }
    this.inputChangeFlag = false;
    this.showSelectFromPlantings = true;
  }

  private selectFromAgriFields(){
    if (this.inputChangeFlag == true) {
      if (!window.confirm("保存していません。よろしいですか？")) {
        return false
      }
    }
    this.inputChangeFlag = false;
    this.showSelectFromAgriFields = true;
  }
}